// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.ReauthenticatePaymentMethodWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ReauthenticatePaymentMethodWebApiRequestDto, ReauthenticatePaymentMethodWebApiResponseDto } from '../..';

export const ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod_Path =
  '/api/web/v1/reauthenticateRenterPaymentMethod';

/**
 * Reauthenticate Renter's Payment Method
 */
export const ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod = (
  postData: ReauthenticatePaymentMethodWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    ReauthenticatePaymentMethodWebApiRequestDto,
    ReauthenticatePaymentMethodWebApiResponseDto
  >(
    {
      endpoint: ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
